export const ENDPOINT = {
  SIGN_IN: `/User/LoginUser`,
  GET_APPLICATION_DATA: `api/Insights/GetApplicationData`,
  USER_UPDATE_ACKNOWLEDGED: `/User/update/Acknowledged`,
  GET_PARTNERS_UTILITYDATA: `api/partners/utilitydata`,
  GET_ADMIN_ENGAGEMENT_DATA: `api/getdata/admin/engagement`,
  GET_ADMIN_FILES_DATA: `api/getdata/admin/files`,
  GET_ADMIN_ORIGINAL_FILE_NAMES: `api/getdata/admin/fileNames`,
  ADMIN_START_ANONYMIZATION: `api/admin/startAnonymization`,
  ADMIN_BOOKMARK_FILE: `api/admin/bookmarkfile`,
  ADMIN_EXPORT_EXCEL_FILTERED_DATA: `api/admin/excel/filteredData`,
  GET_PARTNERS_FILES_ENGAGEMENT: `api/partners/files/engagement`,
  GET_PARTNERS_FILES_BLOCKLIST: `api/partners/files/blocklist`,
  GET_PARTNERS_EDITENGAGEMENTDETAILS: `baseUrl/api/partners/editEngagementDetails`,
  GET_PARTNERS_FILEVALIDATION : `baseUrl/api/partners/FileValidation`,
  GET_PARTNERS_ADD: `baseUrl/api/partners/add`,
  GET_PARTNERS_FILES_DELETE: `baseUrl/api/partners/files/delete`,
  GET_PARTNERS_VIEWFILESCONTENT:`baseUrl/api/partners/ViewFilesContent`,
  PARTNERS_DELETE_TEMP_FILES_ON_POPUP_CLOSE:`baseUrl/api/partners/DeleteTempFilesOnPopupClose`,
  GET_PARTNERS_DOWNLOADFILECONTENT : `baseUrl/api/partners/ViewFilesContent`,
  PARTNERS_IMPORT_BATCH_START: `api/partners/imports/batches/start`,
  PARTNERS_IMPORT_BATCH_LOGS: `api/partners/imports/batches/{importBatchId}/logs`,
  PARTNERS_IMPORT_BATCH_COMPLETE: `api/partners/imports/batches/{importBatchId}/complete`,
  PARTNERS_EDIT_ENGAGEMENT_DETAILS_BULK: `api/partners/editEngagementDetails/bulk`,
  PARTNERS_EDIT_ENGAGEMENT_DETAILS_BULK_REGIONAL: `baseUrl/api/partners/editEngagementDetails/bulk`,
  PARTNERS_SAS_TOKEN:`baseUrl/api/partners/SasToken`,
  PARTNERS_EDIT_ENGAGEMENT_STATUS:`baseUrl/api/partners/editEngagementStatus`,
  PARTNERS_UPLOAD_PROCESSING:`baseUrl/api/partners/UploadProcessing`,
  PARTNERS_UPLOAD_REPROCESSING:`baseUrl/api/partners/UploadReProcessing`,
  PARTNERS_UPLOAD_SHAREPOINT_FILES_TO_BLOB:`baseUrl/api/partners/UploadSharePointFilesToBlob`,
  PARTNERS_ACCESS_GRANT:`baseUrl/api/partners/AccessGrant`,
  PARTNERS_ACCESS_REVOKE:`baseUrl/api/partners/AccessRevoke`,
  PARTNERS_GET_TOTAL_UPLOAD_FILE_COUNT:`api/partners/GetTotalUploadFileCount`,
  PARTNERS_DOWNLOAD_ARC_ARCHIVES:`baseUrl/api/DownLoadArcArchives`,
  PARTNERS_ARC_DOWNLOAD_BATCH_STATUS:`baseUrl/api/ArcArchives/DownloadBatchStatus`,
  ADMIN_COUNT_GOLD_DATA: `api/admin/countGoldData`,
  GET_ADMIN_GROUP_USERS: `api/adminGroupUser/getUsers`,
  ADD_ADMIN_GROUP_USER: `api/adminGroupUser/add`,
  GET_ALL_USERS: `api/users/all`,
  GET_USERS_HISTORY: `api/users/history`,
  EDIT_USER: `api/users/edit`,
  DELETE_USER: `api/users/delete`,
  ADD_USER: `api/users/add`,
  DELETE_ADMIN_GROUP_USER: `api/adminGroupUser/delete`,
  GET_USERS_ROLES: `api/users/roles`,
  PARTNERS_UPLOADED_FILE_STATUS: `baseUrl/api/partners/UploadedFileStatus`,
  PARTNERS_DUPLICATE_FILES: `baseUrl/api/partners/GetDuplicateFiles`,
  PARTNERS_ENABLE_DISABLE_CLIENT_DATA: `baseUrl/api/partners/EnableDisableClientData`,
  PARTNERS_ERROR_SAVE: `api/errors/save`,
  GET_EDGE_UPLOAD_DATA: `api/EdgeUI/data`,
  GET_EDGE_DOWNLOAD_DATA: `api/EdgeUI/download`,
  GET_EDGE_HISTORY_DATA: `api/EdgeUI/history`,
  GET_PLANNED_OUTAGE_ACTIVE: `api/planned-outage/active`,
  GET_PLANNED_OUTAGE_PRIOR: `api/planned-outage/prior`,
  GET_PLANNED_OUTAGE_USERS: `api/admin/planned-outage/getusers`,
  ADD_PLANNED_OUTAGE_USERS: `api/admin/planned-outage/add/users`,
  DELETE_PLANNED_OUTAGE_USERS: `api/admin/planned-outage/delete/users`,
  GET_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_DETAILS: `api/admin/planned-outage/getDeploymentDetails`,
  ADD_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_SCHEDULE: `api/admin/planned-outage/add/DeploymentScheduler`,
  UPDATE_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_SCHEDULE: `api/admin/planned-outage/{id}`,
  GET_EDGE_HISTORY_DATA: `api/EdgeUI/history`,
  CHATBOT_QUERY: `baseUrl/api/DBS/COE/ai-chatbot/query/stream`,
  CHATBOT_TRENDING_QUERIES: `baseUrl/api/Chatbot/trending-queries`,
  CHATBOT_SAVE_HISTORY: `baseUrl/api/Chatbot/chat-history`,
  CHATBOT_LIST_HISTORY: `baseUrl/api/Chatbot/chat-history`,
  CHATBOT_HISTORY_SAS_URL: `baseUrl/api/Chatbot/chat-history/sas-url`,
  CHATBOT_VIEW_FILE_CONTENT: `baseUrl/api/DBS/COE/ai-chatbot/viewfilecontent`,
  CHATBOT_CHAT_LOG: `baseUrl/api/Chatbot/chat/log`,
  CHATBOT_CHAT_FEEDBACK: `baseUrl/api/Chatbot/chat/feedback`
};
